import { Control } from 'react-hook-form'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { ControlledMultiSelectorAssetInput } from '@/ui/organisms/multi-selector/ControlledMultiSelectorAssetInput'
import { BridgeFormSchema, BridgeToken, SwapMode } from '@/features/bridge/logic/useBridge'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { Info } from '@/ui/molecules/info/Info'
import { SearchableAssetSelector } from '@/ui/molecules/searchable-asset-selector/SearchableAssetSelector'
interface ToProps {
  control: Control<BridgeFormSchema>
  assets: BridgeToken[]
  selectedAsset: BridgeToken
  changeToken: (newSymbol: TokenSymbol) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  maxSelectedFieldName?: string
  swapMode: SwapMode
}

export function To(props: ToProps) {
  const { control, assets, selectedAsset, changeToken, onChange, swapMode } = props

  // Determine destination network based on direction
  const destinationNetwork = swapMode === 'bridgeToHyperEVM' ? 'HyperEVM' : 'HyperCore'

  return (
    <Panel.Wrapper className="mt-2 p-4 pb-5">
      <div className="flex flex-row items-center gap-1">
        <Typography variant="h4" className="py-3 font-semibold">
          To {destinationNetwork}
        </Typography>
        {swapMode === 'bridgeToHyperCore' && <Info>HyperCore is name of the Hyperliquid Exchange</Info>}
      </div>
      <div>
        <div className="mt-2 flex flex-row items-start gap-2">
          <ControlledMultiSelectorAssetInput
            fieldName="to.value"
            control={control}
            disabled={true}
            token={selectedAsset.token}
            resetBorrowStatus={() => {}}
            customOnChange={onChange}
            maxSelectedFieldName={'Balance'}
          />

          <SearchableAssetSelector
            assets={assets}
            selectedAsset={selectedAsset.token}
            setSelectedAsset={changeToken}
            isL1={swapMode === 'bridgeToHyperCore'}
            disabled
            isDestination
          />
        </div>
      </div>
    </Panel.Wrapper>
  )
}
